import Vue from "vue";
import { mapGetters } from "vuex";

import buttonIncluirComponent from "@/components/child/form/button/buttonIncluir.vue";
import comboComponent from "@/components/child/form/combo.vue";
import fieldsetComponent from "@/components/child/form/fieldset.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component, Prop } from "@/decorators";
import FranquiaModel from "@/models/franquiaModel";
import ModeloImpressaoUsuarioModel from "@/models/modeloImpressao/modeloImpressaoUsuarioModel";
import UsuarioModel from "@/models/usuarioModel";
import UsuarioService from "@/services/usuarioService";
import { Getters } from "@/store/store";
import { BaseOption } from "@/types/options";
import { any } from "ramda";

@Component({
    components: {
        comboComponent,
        gridComponent,
        fieldsetComponent,
        buttonIncluirComponent,
    },
    computed: {
        ...mapGetters(["GET_FRANQUIA_ATUAL"] as Getters),
    },
})
export default class ModeloImpressaoUsuarioEdit extends Vue {
    // State computed props
    GET_FRANQUIA_ATUAL: () => FranquiaModel;

    private usuarioService = new UsuarioService();

    @Prop({ type: Array, default: () => [] }) impressoraOptions;

    private usuarioOptions: Array<BaseOption> = [];

    get gridColumnsUsuarios(): Array<GridColumn> {
        return [
            new GridColumn("usuarioNome", this.$t("__.ts.usuario"), GridColumnType.String),
            new GridColumn("nomeImpressora", this.$t("__.ts.impressora"), GridColumnType.String),
        ];
    }

    private usuarioId: number | null = null;
    private usuarioImpressora: string | null = null;
    private usuarios: ModeloImpressaoUsuarioModel[] = [];

    public usuariosEditados: boolean = false;

    set setUsuarios(usuarios: ModeloImpressaoUsuarioModel[]) {
        this.usuarios = usuarios;
    }

    get getUsuarios() {
        return this.usuarios;
    }

    private async onInclusaoModeloUsuario() {
        const isValid = await this.$validator.validateAll();
        if (isValid) {
            const usuarioComponent = this.$el.querySelector("#usuarioId") as HTMLSelectElement;

            const alreadyExists = any((usuario: ModeloImpressaoUsuarioModel) => usuario.usuarioId == this.usuarioId);

            if (!alreadyExists(this.usuarios)) {
                const modeloUsuario = new ModeloImpressaoUsuarioModel();

                modeloUsuario.usuarioId = this.usuarioId!;
                modeloUsuario.usuarioNome = usuarioComponent.innerText;
                modeloUsuario.nomeImpressora = this.impressoraOptions[this.usuarioImpressora!].printerName;

                this.usuarios.push(modeloUsuario);

                this.usuariosEditados = true;

                this.usuarioId = null;
                this.usuarioImpressora = null;
            }
        }
    }

    private onRemoveModeloUsuario(data: ModeloImpressaoUsuarioModel) {
        this.usuarios = this.usuarios.filter(p => p.usuarioId != data.usuarioId);
        this.usuariosEditados = true;
    }

    private async mounted() {
        const data = await this.usuarioService
            .listByFranquiaId(this.GET_FRANQUIA_ATUAL().id)
            .resolveWithJSON<UsuarioModel[]>();

        this.usuarioOptions = data.map(item => ({ value: item.id!, text: item.nome }));
    }
}
